// // // src/components/Dashboard.js

// import React, { useEffect, useState } from 'react';
// import {
//   Pane,
//   Heading,
//   Tab,
//   Tablist,
//   Text,
//   Button,
//   Avatar,
//   Icon,
//   EditIcon,
// } from 'evergreen-ui';
// import { useNavigate } from 'react-router-dom';
// import { auth } from '../appservices/firebase';
// import useStore from '../appservices/store';
// import Chat from './Chat';
// import IntegrateEmail from './IntegrateEmail';
// import ActionBoard from './ActionBoard';
// import DatastoreBoard from './Datastore';
// import SummaryBoard from './Summary';
// import SettingsView from './SettingsView';
// import Mailbox from './Mailbox';
// import { doc, getDoc } from 'firebase/firestore'; // Firestore imports
// import { firestore } from '../appservices/firebase'; // Firestore initialization
// import {
//   HomeIcon,
//   DocumentIcon,
//   EnvelopeIcon,
//   CogIcon,
//   LogOutIcon,
//   ChatIcon,
// } from 'evergreen-ui';
// import Overview from './Overview';
// import TicketView from './Ticketview';
// import CalendarView from './Calendar';

// const Dashboard = () => {
//   const [selectedIndex, setSelectedIndex] = useState(0);
//   const { user, setUser } = useStore();
//   const navigate = useNavigate();
//   const [subscriptionStatus, setSubscriptionStatus] = useState(null);
//   const [subscriptionMetadata, setSubscriptionMetadata] = useState({});
//   const [isFetched, setIsFetched] = useState(false); // Track if the subscription data is fetched
//   const [onboardComplete, setOnboardComplete] = useState(null); // Track onboarding status

//   const tabs = [
//     { name: 'Overview', icon: HomeIcon },
//     { name: 'TicketView', icon: EditIcon },
//     // { name: 'Mailbox', icon: HomeIcon },
//     // { name: 'Messages', icon: EnvelopeIcon },
//     // { name: 'Outlook Mail', icon: EnvelopeIcon },
//     // { name: 'Chat with AI', icon: ChatIcon },
//     // { name: 'Action Board', icon: DocumentIcon },
//     { name: 'Datastore', icon: DocumentIcon },
//     { name: 'Calendar', icon: DocumentIcon } // new tab

//     // { name: 'Settings', icon: CogIcon },
//     // { name: 'Overview', icon: EnvelopeIcon },
//   ];

//   // Fetch user data including subscription status and onboarding status
//   useEffect(() => {
//     const fetchUserData = async () => {
//       if (!user) return;

//       try {
//         const docRef = doc(firestore, `Users/${user.uid}`);
//         const docSnapshot = await getDoc(docRef);

//         if (docSnapshot.exists()) {
//           const data = docSnapshot.data();

//           // Set subscription metadata
//           setSubscriptionStatus(data.subscription_status);
//           setSubscriptionMetadata({
//             subscription_id: data.subscription_id,
//             subscription_created_at: data.subscription_created_at,
//             subscription_type: data.subscription_type,
//           });

//           // Check if onboarding is complete
//           setOnboardComplete(data.onboardComplete || false);
//         } else {
//           console.log("No user document found");
//           setSubscriptionStatus(null);
//         }
//       } catch (error) {
//         console.error("Error fetching user data:", error);
//         setSubscriptionStatus(null);
//       } finally {
//         setIsFetched(true); // Mark the data fetch as completed
//       }
//     };

//     fetchUserData();
//   }, [user]);

//   // If onboarding is not complete, redirect to the onboard page
//   useEffect(() => {
//     if (onboardComplete === false) {
//       navigate('/dashboard/onboard');
//     }
//   }, [onboardComplete, navigate]);

//   // Only redirect to checkout if no active subscription and data is fetched
//   useEffect(() => {
//     if (isFetched && subscriptionStatus !== 'active') {
//       navigate('/checkout');
//     }
//   }, [isFetched, subscriptionStatus, navigate]);

//   const handleLogout = async () => {
//     try {
//       await auth.signOut();
//       setUser(null);
//       navigate('/auth');
//     } catch (error) {
//       console.error('Error logging out:', error);
//     }
//   };

//   const handleOpenOutlook = () => {
//     const outlookUrl =
//       user && user.serviceAccountEmail
//         ? `https://outlook.office.com/mail/inbox?login_hint=${encodeURIComponent(
//             user.serviceAccountEmail
//           )}`
//         : 'https://outlook.office.com/mail/inbox';

//     window.open(outlookUrl, '_blank');
//   };

//   return (
//     <Pane display="flex" height="100vh">
//       {/* Sidebar */}
//       <Pane
//         width={250}
//         background="tint2"
//         padding={16}
//         display="flex"
//         flexDirection="column"
//         elevation={1}
//       >
//         <Pane marginBottom={32}>
//           <Heading size={600} marginBottom={16}>
//             Milli Dashboard
//           </Heading>
//           <Avatar
//             name={user ? user.displayName || user.email : 'User'}
//             size={40}
//             marginBottom={16}
//           />
//           <Text>{user ? user.email : 'Welcome, Guest'}</Text>
//         </Pane>

//         <Tablist marginBottom={16} flexDirection="column">
//           {tabs.map((tab, index) => (
//             <Tab
//               key={tab.name}
//               id={tab.name}
//               onSelect={() => setSelectedIndex(index)}
//               isSelected={index === selectedIndex}
//               aria-controls={`panel-${tab.name}`}
//             >
//               <Pane display="flex" alignItems="center">
//                 <Icon icon={tab.icon} marginRight={8} />
//                 <Text>{tab.name}</Text>
//               </Pane>
//             </Tab>
//           ))}
//         </Tablist>

//         {/* Logout Button */}
//         <Button
//           marginTop="auto"
//           iconBefore={LogOutIcon}
//           intent="danger"
//           onClick={handleLogout}
//         >
//           Logout
//         </Button>
//       </Pane>

//       {/* Main Content Area */}
//       <Pane flex="1" padding={16} overflowY="auto">
//         <Pane
//           display="flex"
//           justifyContent="space-between"
//           alignItems="center"
//           marginBottom={24}
//         >
//           <Heading size={700}>
//             Welcome to your Dashboard,{' '}
//             {user ? user.displayName || user.email : 'User'}
//           </Heading>
//           <Avatar
//             name={user ? user.displayName || user.email : 'User'}
//             size={40}
//           />
//         </Pane>

//         {/* Display Subscription Status if available */}
//         {/* {subscriptionStatus && (
//           <Pane marginBottom={24} background="tint1" padding={16} borderRadius={8}>
//             <Heading size={600}>Subscription Information</Heading>
//             <Text>Subscription Status: {subscriptionStatus}</Text>
//             <Text>Subscription ID: {subscriptionMetadata.subscription_id}</Text>
//             <Text>Subscription Type: {subscriptionMetadata.subscription_type}</Text>
//             <Text>Created At: {subscriptionMetadata.subscription_created_at}</Text>
//           </Pane>
//         )} */}

//         {/* <Pane>
//           {selectedIndex === 0 && <SummaryBoard />}
//           {selectedIndex === 1 && <IntegrateEmail />}
//           {selectedIndex === 2 && (
//             <Pane>
//               <Heading size={600} marginBottom={16}>
//                 Outlook Mail
//               </Heading>
//               <Button appearance="primary" onClick={handleOpenOutlook}>
//                 Open Outlook Mail
//               </Button>
//             </Pane>
//           )}
//           {selectedIndex === 3 && <Chat />}
//           {selectedIndex === 4 && <ActionBoard />}
//           {selectedIndex === 5 && <DocumentationBoard />}
//           {selectedIndex === 6 && <SettingsView />}
//           {selectedIndex === 7 && <Mailbox />}
//         </Pane> */}


//     <Pane>
//           {selectedIndex === 0 && <Overview />}
//           {selectedIndex === 1 && < TicketView/>}
//           {/* {selectedIndex === 2 && <Mailbox />} */}

//           {selectedIndex === 2 && <DatastoreBoard />}
//           {selectedIndex === 3 && <CalendarView />} {/* Render the CalendarView */}

//           {/* {selectedIndex === 6 && <SettingsView />} */}
//           {/* {selectedIndex === 2 && <SummaryBoard />} */}
//         </Pane>
//       </Pane>
//     </Pane>
//   );
// };

// export default Dashboard;



// import React, { useEffect, useState } from 'react';
// import {
//   Pane,
//   Heading,
//   Tab,
//   Tablist,
//   Text,
//   Button,
//   Avatar,
//   Icon,
//   LogOutIcon,
// } from 'evergreen-ui';
// import { useNavigate } from 'react-router-dom';
// import { auth } from '../appservices/firebase';
// import useStore from '../appservices/store';
// import Overview from './Overview';
// import TicketView from './Ticketview';
// import DatastoreBoard from './Datastore';
// import CalendarView from './Calendar';
// import { doc, getDoc } from 'firebase/firestore';
// import { firestore } from '../appservices/firebase';

// import { HomeIcon, EditIcon, DocumentIcon } from 'evergreen-ui';

// const Dashboard = () => {
//   const [selectedIndex, setSelectedIndex] = useState(0);
//   const { user, setUser } = useStore();
//   const navigate = useNavigate();
//   const [subscriptionStatus, setSubscriptionStatus] = useState(null);
//   const [subscriptionMetadata, setSubscriptionMetadata] = useState({});
//   const [isFetched, setIsFetched] = useState(false);
//   const [onboardComplete, setOnboardComplete] = useState(null);

//   const tabs = [
//     { name: 'Overview', icon: HomeIcon },
//     { name: 'TicketView', icon: EditIcon },
//     { name: 'Datastore', icon: DocumentIcon },
//     { name: 'Calendar', icon: DocumentIcon },
//   ];

//   useEffect(() => {
//     const fetchUserData = async () => {
//       if (!user) return;

//       try {
//         const docRef = doc(firestore, `Users/${user.uid}`);
//         const docSnapshot = await getDoc(docRef);

//         if (docSnapshot.exists()) {
//           const data = docSnapshot.data();

//           setSubscriptionStatus(data.subscription_status);
//           setSubscriptionMetadata({
//             subscription_id: data.subscription_id,
//             subscription_created_at: data.subscription_created_at,
//             subscription_type: data.subscription_type,
//           });

//           setOnboardComplete(data.onboardComplete || false);
//         } else {
//           console.error('No user document found');
//           setSubscriptionStatus(null);
//         }
//       } catch (error) {
//         console.error('Error fetching user data:', error);
//         setSubscriptionStatus(null);
//       } finally {
//         setIsFetched(true);
//       }
//     };

//     fetchUserData();
//   }, [user]);

//   useEffect(() => {
//     if (onboardComplete === false) {
//       navigate('/dashboard/onboard');
//     }
//   }, [onboardComplete, navigate]);

//   useEffect(() => {
//     if (isFetched && subscriptionStatus !== 'active') {
//       navigate('/checkout');
//     }
//   }, [isFetched, subscriptionStatus, navigate]);

//   const handleLogout = async () => {
//     try {
//       await auth.signOut();
//       setUser(null);
//       navigate('/auth');
//     } catch (error) {
//       console.error('Error logging out:', error);
//     }
//   };

//   return (
//     <Pane display="flex" height="100vh">
//       {/* Sidebar */}
//       <Pane
//         width={250}
//         background="tint2"
//         padding={16}
//         display="flex"
//         flexDirection="column"
//         elevation={1}
//       >
//         <Pane marginBottom={32}>
//           <Heading size={600} marginBottom={16}>
//             Milli Dashboard
//           </Heading>
//           <Avatar
//             name={user ? user.displayName || user.email : 'User'}
//             size={40}
//             marginBottom={16}
//           />
//           <Text>{user ? user.email : 'Welcome, Guest'}</Text>
//         </Pane>

//         <Tablist marginBottom={16} flexDirection="column">
//           {tabs.map((tab, index) => (
//             <Tab
//               key={tab.name}
//               id={tab.name}
//               onSelect={() => setSelectedIndex(index)}
//               isSelected={index === selectedIndex}
//               aria-controls={`panel-${tab.name}`}
//             >
//               <Pane display="flex" alignItems="center">
//                 <Icon icon={tab.icon} marginRight={8} />
//                 <Text>{tab.name}</Text>
//               </Pane>
//             </Tab>
//           ))}
//         </Tablist>

//         <Button
//           marginTop="auto"
//           iconBefore={LogOutIcon}
//           intent="danger"
//           onClick={handleLogout}
//         >
//           Logout
//         </Button>
//       </Pane>

//       {/* Main Content */}
//       <Pane flex="1" padding={16} overflowY="auto">
//         <Pane
//           display="flex"
//           justifyContent="space-between"
//           alignItems="center"
//           marginBottom={24}
//         >
//           <Heading size={700}>
//             Welcome to your Dashboard,{' '}
//             {user ? user.displayName || user.email : 'User'}
//           </Heading>
//           <Avatar
//             name={user ? user.displayName || user.email : 'User'}
//             size={40}
//           />
//         </Pane>

//         <Pane>
//           {selectedIndex === 0 && <Overview />}
//           {selectedIndex === 1 && <TicketView />}
//           {selectedIndex === 2 && <DatastoreBoard />}
//           {selectedIndex === 3 && <CalendarView />}
//         </Pane>
//       </Pane>
//     </Pane>
//   );
// };

// export default Dashboard;

import React, { useEffect, useState } from 'react';
import {
  Pane,
  Heading,
  Tab,
  Tablist,
  Text,
  Button,
  Avatar,
  Icon,
  LogOutIcon,
} from 'evergreen-ui';
import { useNavigate } from 'react-router-dom';
import useStore from '../appservices/store';
import { auth, firestore } from '../appservices/firebase';
import { doc, getDoc } from 'firebase/firestore';

import Overview from './Overview';
import TicketView from './Ticketview';
import DatastoreBoard from './Datastore';
import CalendarView from './Calendar';

import {
  HomeIcon,
  EditIcon,
  DocumentIcon,
  CalendarIcon,
} from 'evergreen-ui';

const Dashboard = () => {
  const { user, setUser, subscriptionStatus, onboardComplete, setOnboardComplete, setSubscriptionStatus } = useStore();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [subscriptionMetadata, setSubscriptionMetadata] = useState({});
  const [isFetched, setIsFetched] = useState(false); // Track if data fetch is complete
  const navigate = useNavigate();

  const tabs = [
    { name: 'Overview', icon: HomeIcon },
    { name: 'Ticket View', icon: EditIcon },
    { name: 'Datastore', icon: DocumentIcon },
    { name: 'Calendar', icon: CalendarIcon },
  ];

  // Fetch user data including subscription and onboarding status
  useEffect(() => {
    const fetchUserData = async () => {
      if (!user) return;

      try {
        const docRef = doc(firestore, `Users/${user.uid}`);
        const docSnapshot = await getDoc(docRef);

        if (docSnapshot.exists()) {
          const data = docSnapshot.data();

          // Update Zustand store with subscription status
          setSubscriptionStatus(data.subscription_status);
          setOnboardComplete(data.onboardComplete || false);

          // Set subscription metadata
          setSubscriptionMetadata({
            subscription_id: data.subscription_id,
            subscription_created_at: data.subscription_created_at,
            subscription_type: data.subscription_type,
          });
        } else {
          console.log("No user document found.");
          setSubscriptionStatus(null);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        setSubscriptionStatus(null);
      } finally {
        setIsFetched(true);
      }
    };

    fetchUserData();
  }, [user, setSubscriptionStatus, setOnboardComplete]);

  // Redirect to onboarding if not complete
  useEffect(() => {
    if (onboardComplete === false) {
      navigate('/dashboard/onboard');
    }
  }, [onboardComplete, navigate]);

  // Redirect to checkout if no active subscription
  useEffect(() => {
    if (isFetched && subscriptionStatus !== 'active') {
      navigate('/checkout');
    }
  }, [isFetched, subscriptionStatus, navigate]);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setUser(null);
      navigate('/auth');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <Pane display="flex" height="100vh">
      {/* Sidebar */}
      <Pane
        width={250}
        background="tint2"
        padding={16}
        display="flex"
        flexDirection="column"
        elevation={1}
      >
        <Pane marginBottom={32}>
          <Heading size={600} marginBottom={16}>
            Milli Dashboard
          </Heading>
          <Avatar
            name={user ? user.displayName || user.email : 'User'}
            size={40}
            marginBottom={16}
          />
          <Text>{user ? user.email : 'Welcome, Guest'}</Text>
        </Pane>

        <Tablist marginBottom={16} flexDirection="column">
          {tabs.map((tab, index) => (
            <Tab
              key={tab.name}
              id={tab.name}
              onSelect={() => setSelectedIndex(index)}
              isSelected={index === selectedIndex}
              aria-controls={`panel-${tab.name}`}
            >
              <Pane display="flex" alignItems="center">
                <Icon icon={tab.icon} marginRight={8} />
                <Text>{tab.name}</Text>
              </Pane>
            </Tab>
          ))}
        </Tablist>

        <Button
          marginTop="auto"
          iconBefore={LogOutIcon}
          intent="danger"
          onClick={handleLogout}
        >
          Logout
        </Button>
      </Pane>

      {/* Main Content */}
      <Pane flex="1" padding={16} overflowY="auto">
        <Pane
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom={24}
        >
          <Heading size={700}>
            Welcome to your Dashboard, {user ? user.displayName || user.email : 'User'}
          </Heading>
        </Pane>

        {/* Render Active Tab Content */}
        <Pane>
          {selectedIndex === 0 && <Overview />}
          {selectedIndex === 1 && <TicketView />}
          {selectedIndex === 2 && <DatastoreBoard />}
          {selectedIndex === 3 && <CalendarView />}
        </Pane>
      </Pane>
    </Pane>
  );
};

export default Dashboard;

